import { queryOptions, useQuery } from '@tanstack/react-query';
import { getDefaultPage } from '@linkie/api-client';
const getDefaultPageQueryOptions = (userId) => {
    return queryOptions({
        queryKey: ['default-page', userId],
        queryFn: () => getDefaultPage(userId),
    });
};
const useGetDefaultPage = (userId, { queryConfig } = {}) => {
    return useQuery(Object.assign(Object.assign({}, getDefaultPageQueryOptions(userId)), queryConfig));
};
export default useGetDefaultPage;
//# sourceMappingURL=useGetDefaultPage.hook.js.map